import React from "react";
import {createTheme, CssBaseline, ThemeProvider} from "@mui/material";
import {MainPage} from "./Page/MainPage.tsx";
import {Route, Routes} from "react-router";
import {GamePage} from "./Page/GamePage.tsx";

function App(): React.ReactElement {
    const darkTheme = createTheme({
	    palette: {
		    mode: "dark"
	    }
    })

    return <ThemeProvider theme={darkTheme}>
        <CssBaseline />
	    <Routes>
		    <Route path={"/"} element={<MainPage />} />
		    <Route path={"/:id"} element={<GamePage />} />
	    </Routes>
    </ThemeProvider>
}

export default App
